import React, { useState } from 'react'
import { OneModal } from '@yy/one-ui'
import { useTranslation } from '../../../hooks'
import { powerBy } from '../index'
import styles from './index.module.less'

const Policy: React.FC = () => {
  const [visible, setVisible] = useState<boolean>(false)
  const { t } = useTranslation()
  return (
    <>
      <span className={styles.privatePolicy} onClick={() => setVisible((value) => !value)}>
        {t('feedback.checkbox')}
      </span>
      <OneModal wrapClassName={styles.policyModal} visible={visible} width="400px" footer={null} onCancel={() => setVisible(false)}>
        <div className={styles.policyText}>
          By activating the recording feature, you acknowledge and agree that {powerBy} will collect all information, data and behavior captured by the video recording, which may
          include personal information and business sensitive information. We will delete such information after it is no longer needed for the purpose of troubleshooting the
          relevant issues. The information collected by {powerBy} is govered by{' '}
          <a href="https://oneship.io/privacy" target="_blank">
            {powerBy} Privacy Policy
          </a>
          .
        </div>
      </OneModal>
    </>
  )
}

export default Policy
